import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentCentre24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextAlignmentCentre24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20.258 7.5a.75.75 0 0 0 0-1.5H3.766a.75.75 0 1 0 0 1.5zm-.021 7a.75.75 0 0 0 0-1.5H3.724a.75.75 0 0 0 0 1.5zM18 10.25a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1 0-1.5h10.5a.75.75 0 0 1 .75.75M17.25 18a.75.75 0 0 0 0-1.5H6.75a.75.75 0 0 0 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentCentre24);
